import React from "react";
import { FileText, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const MARKING_PDF = "/marking-pattern.pdf";

export default function MarkingPatternModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[95vh] w-[96vw] max-w-4xl flex-col gap-0 overflow-hidden p-0" data-testid="marking-pattern-modal">
        <div className="flex items-center gap-2.5 border-b-2 border-[#f1ead7] bg-[#fbf9f2] px-5 py-4">
          <FileText className="h-5 w-5 shrink-0 text-[#1b5e3f]" />
          <DialogTitle className="font-head flex-1 text-[16px] font-semibold text-[#1b5e3f] sm:text-[18px]">
            निवड प्रक्रिया — गुण विभागणी (एकूण १०० गुण)
          </DialogTitle>
          <DialogDescription className="sr-only">अर्ज भरण्यापूर्वी गुण विभागणी तक्ता वाचा.</DialogDescription>
          <a
            href={MARKING_PDF}
            target="_blank"
            rel="noreferrer"
            data-testid="marking-open-newtab"
            className="inline-flex items-center gap-1.5 rounded-lg border border-[#1b5e3f]/25 bg-white px-3 py-1.5 text-[12.5px] font-semibold text-[#1b5e3f] hover:bg-[#f6f2e6]"
          >
            <ExternalLink className="h-3.5 w-3.5" /> नवीन टॅब
          </a>
        </div>
        <div className="bg-[#fdf7e5] px-5 py-2.5 text-[13px] leading-relaxed text-[#8a5a06]">
          कृपया अर्ज भरण्यापूर्वी खालील <strong>गुण विभागणी तक्ता</strong> काळजीपूर्वक वाचा. प्रत्येक टप्प्यातील माहिती व कागदपत्रे यानुसार गुण दिले जातात.
        </div>
        <div className="min-h-0 w-full flex-1 bg-slate-100">
          <iframe title="गुण विभागणी" src={MARKING_PDF} className="h-full w-full border-0" />
        </div>
        <div className="flex justify-end border-t-2 border-[#f1ead7] bg-[#fbf9f2] px-5 py-3">
          <button
            onClick={() => onOpenChange(false)}
            data-testid="marking-close-btn"
            className="rounded-lg bg-[#5a9e3a] px-6 py-2 text-[14px] font-semibold text-white hover:opacity-90"
          >
            वाचले, अर्ज भरा
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
